import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Box, Grid, SectionTitle, Text, List, ListItem, ListItemText,Typography } from '@blueprint/ui';

const BsmTncPlaceholder = styled.div`
    padding-top: 100px;
    padding-right: 5vw;
    padding-left: 5vw;
    padding-bottom: 5em;
`;

const BsmTnc = () => {
    const { t } = useTranslation();
    return (
        <BsmTncPlaceholder>
            <Box>
                <Box>
                    <Box borderLeft='3px solid red' margin='0 0 2vw 0' paddingLeft='10px'>
                        <Typography variant='h1' className='page-title' tabIndex='-1'>
                            {t('bsmTnc.bsmWebsiteTnc')}
                        </Typography>
                    </Box>
                </Box>

                <Box margin='0 0 10px 0'>
                    <Text variant='body1' fontWeight='bold'>
                        {t('bsmTnc.beforeUse')}
                    </Text>
                </Box>
                <Box margin='0 0 10px 0'>
                    <Text variant='body1' fontWeight='bold'>
                        <u>{t('bsmTnc.definitions')}</u>
                    </Text>
                </Box>
                <Box margin='0 0 10px 0'>
                    <Text variant='body1'>{t('bsmTnc.definitionPara1')}</Text>
                </Box>
                <Box margin='0 0 10px 0'>
                    <Text variant='body1'>
                        <b>“BSM Service”</b> {t('bsmTnc.definitionPara2')}
                    </Text>
                </Box>
                <Box margin='0 0 10px 0'>
                    <Text variant='body1'>
                        <b>"HSBC Group"</b> or <b>"HSBC Group Member"</b> or <b>“we”</b> or <b>“us”</b> {t('bsmTnc.definitionPara3')}{' '}
                    </Text>
                </Box>
                <Box margin='0 0 10px 0'>
                    <Text variant='body1'>
                        <b>“HSBC”</b> {t('bsmTnc.definitionPara4')}
                    </Text>
                </Box>
                <Box margin='0 0 10px 0'>
                    <Text variant='body1'>
                        <b>"Payor"</b> {t('bsmTnc.definitionPara5')}
                    </Text>
                </Box>
                <Box margin='0 0 10px 0'>
                    <Text variant='body1'>
                        <b>“Portal”</b> {t('bsmTnc.definitionPara6')}
                    </Text>
                </Box>
                <Box margin='0 0 10px 0'>
                    <Text variant='body1'>
                        <b>“you”</b>, <b>“your"</b> and <b>“yours” </b> {t('bsmTnc.definitionPara7')}
                    </Text>
                </Box>
                <Box margin='15px 0 10px 0'>
                    <Text variant='body1' fontWeight='bold'>
                        <u>{t('bsmTnc.portal')}</u>
                    </Text>
                </Box>
                <Box margin='0 0 10px 0'>
                    <Text variant='body1'>{t('bsmTnc.portalPara1')}</Text>
                </Box>
                <Box margin='0 0 10px 0'>
                    <Text variant='body1'>{t('bsmTnc.portalPara2')}</Text>
                </Box>

                {/* TERMS */}
                <Box margin='15px 0 5px 0'>
                    <Text variant='body1' fontWeight='bold'>
                        <u>{t('bsmTnc.pleaseReadTheseTerms')}</u>
                    </Text>
                </Box>
                <Box margin='0 0 10px 0'>
                    <Text variant='body1'>{t('bsmTnc.termsPara1')}</Text>
                </Box>
                <Box margin='0 0 10px 0'>
                    <Text variant='body1'>{t('bsmTnc.termsPara2')}</Text>
                </Box>

                {/* COMMUNICATIONS */}
                <Box margin='15px 0 5px 0'>
                    <Text variant='body1' fontWeight='bold'>
                        <u>{t('bsmTnc.communications')}</u>
                    </Text>
                </Box>
                <Box margin='0 0 5px 0'>
                    <Text variant='body1'>{t('bsmTnc.messagesSentOver')}</Text>
                </Box>
                <Box margin='0 0 5px 0'>
                    <Text variant='body1'>{t('bsmTnc.neitherWeDoOrAny')}</Text>
                </Box>
                <Box margin='0 0 5px 0'>
                    <Text variant='body1'>{t('bsmTnc.toHelpUsImprove')}</Text>
                </Box>
                <Box margin='0 0 5px 0'>
                    <Text variant='body1'>{t('bsmTnc.itIsTheExpress')}</Text>
                </Box>

                {/* NO LIABILITY */}
                <Box margin='15px 0 5px 0'>
                    <Text variant='body1' fontWeight='bold'>
                        <u>{t('bsmTnc.noLiability')}</u>
                    </Text>
                </Box>
                <Box margin='0 0 5px 0'>
                    <Text variant='body1'>{t('bsmTnc.noLiabilityPara1')}</Text>
                </Box>
                <Box margin='0 0 5px 0'>
                    <Text variant='body1'>{t('bsmTnc.noLiabilityPara2')}</Text>
                </Box>
                <Box margin='0 0 5px 0'>
                    <Text variant='body1'>{t('bsmTnc.noLiabilityPara3')}</Text>
                </Box>
                <List listStyleType='lower-alpha'>
                    <ListItem>
                        <Box margin='0 0 5px 0'>
                            <Text variant='body1'>{t('bsmTnc.noLiabilityPointA')}</Text>
                        </Box>
                        <List listStyleType='lower-roman'>
                            <ListItem>
                                <Box margin='0 0 5px 0'>
                                    <Text variant='body1'>{t('bsmTnc.noLiabilityPoint1')}</Text>
                                </Box>
                            </ListItem>
                            <ListItem>
                                <Box margin='0 0 5px 0'>
                                    <Text variant='body1'>{t('bsmTnc.noLiabilityPoint2')}</Text>
                                </Box>
                            </ListItem>
                            <ListItem>
                                <Box margin='0 0 5px 0'>
                                    <Text variant='body1'>{t('bsmTnc.noLiabilityPoint3')}</Text>
                                </Box>
                            </ListItem>
                        </List>
                    </ListItem>
                    <ListItem>
                        <Box margin='0 0 5px 0'>
                            <Text variant='body1'>{t('bsmTnc.noLiabilityPointB')}</Text>
                        </Box>
                        <List listStyleType='lower-roman'>
                            <ListItem>
                                <Box margin='0 0 5px 0'>
                                    <Text variant='body1'>{t('bsmTnc.noLiabilityPoint4')}</Text>
                                </Box>
                            </ListItem>
                            <ListItem>
                                <Box margin='0 0 5px 0'>
                                    <Text variant='body1'>{t('bsmTnc.noLiabilityPoint5')}</Text>
                                </Box>
                            </ListItem>
                            <ListItem>
                                <Box margin='0 0 5px 0'>
                                    <Text variant='body1'>{t('bsmTnc.noLiabilityPoint6')}</Text>
                                </Box>
                            </ListItem>
                        </List>
                    </ListItem>
                    <ListItem>
                        <Box margin='0 0 5px 0'>
                            <Text variant='body1'>{t('bsmTnc.noLiabilityPointC')}</Text>
                        </Box>
                        <List listStyleType='lower-roman'>
                            <ListItem>
                                <Box margin='0 0 5px 0'>
                                    <Text variant='body1'>{t('bsmTnc.noLiabilityPoint7')}</Text>
                                </Box>
                            </ListItem>
                            <ListItem>
                                <Box margin='0 0 5px 0'>
                                    <Text variant='body1'>{t('bsmTnc.noLiabilityPoint8')}</Text>
                                </Box>
                            </ListItem>
                            <ListItem>
                                <Box margin='0 0 5px 0'>
                                    <Text variant='body1'>{t('bsmTnc.noLiabilityPoint9')}</Text>
                                </Box>
                            </ListItem>
                        </List>
                    </ListItem>
                </List>

                {/* Linked Sites */}
                <Box margin='15px 0 5px 0'>
                    <Text variant='body1' fontWeight='bold'>
                        <u>{t('bsmTnc.linkedSites')}</u>
                    </Text>
                </Box>
                <Box>
                    <Text variant='body1'>{t('bsmTnc.linkedSitesPara1')}</Text>
                </Box>
                <Box>
                    <Text variant='body1'>{t('bsmTnc.linkedSitesPara2')}</Text>
                </Box>

                {/* Responsibility */}
                <Box margin='15px 0 5px 0'>
                    <Text variant='body1' fontWeight='bold'>
                        <u>{t('bsmTnc.responsibility')}</u>
                    </Text>
                </Box>
                <Box>
                    <Text variant='body1'>{t('bsmTnc.responsibilityPara1')}</Text>
                </Box>
                <Box>
                    <Text variant='body1'>{t('bsmTnc.responsibilityPara2')}</Text>
                </Box>
                <List listStyleType='lower-alpha'>
                    <ListItem>
                        <Box margin='0 0 5px 0'>
                            <Text variant='body1'>{t('bsmTnc.responsibilityPoint1')}</Text>
                        </Box>
                    </ListItem>
                    <ListItem>
                        <Box margin='0 0 5px 0'>
                            <Text variant='body1'>{t('bsmTnc.responsibilityPoint2')}</Text>
                        </Box>
                    </ListItem>
                    <ListItem>
                        <Box margin='0 0 5px 0'>
                            <Text variant='body1'>{t('bsmTnc.responsibilityPoint3')}</Text>
                        </Box>
                    </ListItem>
                </List>

                {/* Miscellaneous */}
                <Box margin='15px 0 5px 0'>
                    <Text variant='body1' fontWeight='bold'>
                        <u>{t('bsmTnc.miscellaneous')}</u>
                    </Text>
                </Box>
                <Box>
                    <Text variant='body1'>{t('bsmTnc.miscellaneousPara1')}</Text>
                </Box>
                <List listStyleType='lower-alpha'>
                    <ListItem>
                        <Box margin='0 0 5px 0'>
                            <Text variant='body1'>{t('bsmTnc.miscellaneousPoint1')}</Text>
                        </Box>
                    </ListItem>
                    <ListItem>
                        <Box margin='0 0 5px 0'>
                            <Text variant='body1'>{t('bsmTnc.miscellaneousPoint2')}</Text>
                        </Box>
                    </ListItem>
                </List>
                <Box>
                    <Text variant='body1'>{t('bsmTnc.miscellaneousPara2')}</Text>
                </Box>
                <Box>
                    <Text variant='body1'>{t('bsmTnc.miscellaneousPara3')}</Text>
                </Box>
                <Box>
                    <Text variant='body1'>{t('bsmTnc.miscellaneousPara4')}</Text>
                </Box>
                <Box>
                    <Text variant='body1'>{t('bsmTnc.miscellaneousPara5')}</Text>
                </Box>
                <Box>
                    <Text variant='body1'>{t('bsmTnc.miscellaneousPara6')}</Text>
                </Box>
                <Box>
                    <Text variant='body1'>{t('bsmTnc.miscellaneousPara7')}</Text>
                </Box>

                {/* VARIATION */}
                <Box margin='15px 0 5px 0'>
                    <Text variant='body1' fontWeight='bold'>
                        <u>{t('bsmTnc.variation')}</u>
                    </Text>
                </Box>
                <Box>
                    <Text variant='body1'>{t('bsmTnc.variationPara')}</Text>
                </Box>

                {/* TERMINATION */}
                <Box margin='15px 0 5px 0'>
                    <Text variant='body1' fontWeight='bold'>
                        <u>{t('bsmTnc.termination')}</u>
                    </Text>
                </Box>
                <Box>
                    <Text variant='body1'>{t('bsmTnc.terminationPara1')}</Text>
                </Box>
                <List listStyleType='lower-alpha'>
                    <ListItem>
                        <Box margin='0 0 5px 0'>
                            <Text variant='body1'>{t('bsmTnc.terminationPoint1')}</Text>
                        </Box>
                    </ListItem>
                    <ListItem>
                        <Box margin='0 0 5px 0'>
                            <Text variant='body1'>{t('bsmTnc.terminationPoint2')}</Text>
                        </Box>
                    </ListItem>
                    <ListItem>
                        <Box margin='0 0 5px 0'>
                            <Text variant='body1'>{t('bsmTnc.terminationPoint3')}</Text>
                        </Box>
                    </ListItem>
                    <ListItem>
                        <Box margin='0 0 5px 0'>
                            <Text variant='body1'>{t('bsmTnc.terminationPoint4')}</Text>
                        </Box>
                    </ListItem>
                    <ListItem>
                        <Box margin='0 0 5px 0'>
                            <Text variant='body1'>{t('bsmTnc.terminationPoint5')}</Text>
                        </Box>
                    </ListItem>
                    <ListItem>
                        <Box margin='0 0 5px 0'>
                            <Text variant='body1'>{t('bsmTnc.terminationPoint6')}</Text>
                        </Box>
                    </ListItem>
                    <ListItem>
                        <Box margin='0 0 5px 0'>
                            <Text variant='body1'>{t('bsmTnc.terminationPoint7')}</Text>
                        </Box>
                    </ListItem>
                    <ListItem>
                        <Box margin='0 0 5px 0'>
                            <Text variant='body1'>{t('bsmTnc.terminationPoint8')}</Text>
                        </Box>
                    </ListItem>
                    <ListItem>
                        <Box margin='0 0 5px 0'>
                            <Text variant='body1'>{t('bsmTnc.terminationPoint9')}</Text>
                        </Box>
                    </ListItem>
                    <ListItem>
                        <Box margin='0 0 5px 0'>
                            <Text variant='body1'>{t('bsmTnc.terminationPoint10')}</Text>
                        </Box>
                    </ListItem>
                    <ListItem>
                        <Box margin='0 0 5px 0'>
                            <Text variant='body1'>{t('bsmTnc.terminationPoint11')}</Text>
                        </Box>
                    </ListItem>
                    <ListItem>
                        <Box margin='0 0 5px 0'>
                            <Text variant='body1'>{t('bsmTnc.terminationPoint12')}</Text>
                        </Box>
                    </ListItem>
                    <ListItem>
                        <Box margin='0 0 5px 0'>
                            <Text variant='body1'>{t('bsmTnc.terminationPoint13')}</Text>
                        </Box>
                    </ListItem>
                </List>
                <Box>
                    <Text variant='body1'>{t('bsmTnc.terminationPara2')}</Text>
                </Box>
                <List listStyleType='lower-alpha'>
                    <ListItem>
                        <Box margin='0 0 5px 0'>
                            <Text variant='body1'>{t('bsmTnc.terminationPoint14')}</Text>
                        </Box>
                    </ListItem>
                    <ListItem>
                        <Box margin='0 0 5px 0'>
                            <Text variant='body1'>{t('bsmTnc.terminationPoint15')}</Text>
                        </Box>
                    </ListItem>
                </List>

                {/* JURISDICTION */}
                <Box margin='15px 0 5px 0'>
                    <Text variant='body1' fontWeight='bold'>
                        <u>{t('bsmTnc.jurisdiction')}</u>
                    </Text>
                </Box>
                <Box>
                    <Text variant='body1'>{t('bsmTnc.jurisdictionPara')}</Text>
                </Box>
            </Box>
        </BsmTncPlaceholder>
    );
};

export default BsmTnc;
